import styled from 'styled-components';
import { t } from '../Table.styles';
import ListContent, { ListData } from '../ListContent';

const ItemAddress = ({ data }: any) => {
  const newArr = JSON.parse(data);
  const flattenedArray = newArr.flat();

  const addressdata: ListData[] = [
    { label: '지번', value: flattenedArray[0] },
    { label: '도로명주소', value: flattenedArray[1] },
  ];

  return (
    <Container>
      <Block>
        <Title>
          <img src="/assets/images/icon/location-map.svg" alt="" />
          <span>소재지</span>
        </Title>
        <ListContent data={addressdata} />
      </Block>
    </Container>
  );
};

export default ItemAddress;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: Spoqa Han Sans Neo;
  background-color: #fff;
`;

const Block = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Title = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-size: 16px;
  font-weight: 500;
  color: #222;
`;
